import React, { useState } from 'react';
import { connect } from "react-redux";
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './CollectorEditionBlock.scss';

import Filter from "../../Elements/Filter/Filter";
import Title from "../../Elements/Title/Title";

// @ts-ignore
import Fade from "react-reveal/Fade";
// @ts-ignore
import Reveal from "react-reveal/Reveal";
import { sendEvent } from "../../../utils";

interface ICollectorEditionBlockProps {
  context?: IContent;
  products?: any;
}

const CollectorEditionBlock = ({ context, products }: ICollectorEditionBlockProps) => {
  const { collector_edition } = context;
  const storeExclusivePath = require(`../../../assets/store-only.png`);
  const collectorEditionDesktopPath = require(`../../../assets/collector-edition.jpg`);
  const collectorEditionMobilePath = require(`../../../assets/collector-edition-mobile.png`);

  const collectorEditionExists = (Object.keys(products).length === 0 && products.constructor === Object) ? true : !!products[collector_edition.id_product];

  const expandFeatures = (e: any) => {
    e.preventDefault();
    const parentNode: HTMLElement = document.querySelector(".block-collector-edition .list-features .mobile-hidden");
    const showMoreNode: HTMLElement = document.querySelector(".block-collector-edition .list-features .show-more");
    if (!parentNode.classList.contains('active')) {
      parentNode.classList.add('active');
      parentNode.style.height = 'auto';
      const height = parentNode.clientHeight + 'px';
      parentNode.style.height = '0px';
      setTimeout(function () {
        parentNode.style.height = height;
        showMoreNode.classList.add("opened");
        parentNode.addEventListener('transitionend', function () {
          parentNode.style.height = 'auto';
        }, {
          once: true
        });
      }, 0);
    } else {
      parentNode.style.height = parentNode.clientHeight + 'px';
      setTimeout(function () {
        parentNode.style.height = '0px';
        parentNode.addEventListener('transitionend', function() {
          parentNode.classList.remove('active');
          showMoreNode.classList.remove("opened");
        }, {
          once: true
        });
      }, 0);
    }
  };

  return collector_edition.is_active === "TRUE" && collectorEditionExists && (
    <Reveal onReveal={() => sendEvent("compare collector - tab displayed - scroll")}>
      <div className="block-collector-edition">
        <div className="container">
          <Title headline={collector_edition.title.headline} baseline={collector_edition.title.baseline} color="#000000" />
          <div className="store-exclusive">
            <img src={storeExclusivePath} alt="" />
          </div>
          <div className="image-mobile">
            <img src={collectorEditionMobilePath} alt="" />
          </div>
          <div className="content">
            <div className="list-features">
              <div className="mobile-showed">
                {collector_edition.items.slice(0, 2).map((item: any, index: number) => (
                  <div className="feature" key={index}>{item}</div>
                ))}
              </div>
              <div className="mobile-hidden">
                {collector_edition.items.slice(2).map((item: any, index: number) => (
                  <div className="feature" key={index}>{item}</div>
                ))}
              </div>
              <button className="show-more" onClick={(e) => expandFeatures(e)}>{collector_edition.show_more}</button>
            </div>
            <div className="image-desktop">
              <Fade delay={200} duration={600}>
                <img src={collectorEditionDesktopPath} alt="" />
              </Fade>
            </div>
            <Filter
              title={collector_edition.select.title}
              onlyCollectorEdition={true}
              defaultSelected={collector_edition.filter && collector_edition.filter.default_selected}
            />
          </div>
        </div>
      </div>
    </Reveal>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.app.products
});

export default connect(mapStateToProps)(withContent(CollectorEditionBlock));
